import React from 'react';
import Brand from './Brand';
import styled from 'styled-components/macro';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 117px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px;

  @media screen and (max-width: 400px) {
    flex-wrap: wrap;
    justify-content: center;
    height: auto;
  }

  & > .right {
    display: flex;
    height: 100%;
    align-items: flex-end;

    & > .slug {
      font-family: Roboto;
      font-weight: bold;
      font-size: 16px;
      color: #3a4851;
      letter-spacing: 1.5px;
      text-align: right;
      text-transform: uppercase;

      @media screen and (max-width: 400px) {
        text-align: center;
      }
    }
  }
`;

const Header = () => (
  <Wrapper>
    <Brand />

    <div className="right">
      <div className="slug">Creating Profitable Companies</div>
    </div>
  </Wrapper>
);

export default Header;
